<template>
	<modal-body
		v-if="chForm != null"
		:chForm="chForm"
		noHeader
		noFooter
		noModal
	/>
	<div v-else class="msg">
		<i class="fa fa-spin fa-spinner"></i>
		Carregando Metadata...
	</div>
</template>
<script>
	import modalBody from '../components/models/create-form/components/mdFormLoad.vue';
	import WBS from 'js/http';
	import { clone } from 'lodash';

	export default {
		name: 'AppCntSmartForm',
		components: {
			modalBody,
		},
		props: {
			cod: {
				required: true,
			},
			value: {
				default: 'initial',
			},
		},
		data() {
			return {
				chForm: null,
			};
		},
		watch: {
			getData: function (t) {
				this.$emit('input', t);
			},
		},
		computed: {
			getData() {
				let resp = [];
				if (this.chForm == null) return resp;
				this.chForm.inputs.forEach((item) => {
					if (item.type != 'msg') {
						resp.push({
							id: item.id,
							value: item.value,
							cod_form: this.chForm.cod,
						});
					}
				});
				return resp;
			},
		},
		methods: {
			clear() {
				this.chForm.inputs.forEach((item, id) => {
					if (item.type == 'checkbox' || item.type == 'table') {
						this.$set(this.chForm.inputs[id], 'value', []);
					} else {
						this.$set(this.chForm.inputs[id], 'value', '');
					}
				});
			},
			load(data) {
				setTimeout((a) => {
					data.forEach((inp) => {
						if (inp.cod_form == this.chForm.cod) {
							let index = this.chForm.inputs.findIndex(
								(item) => item.id == inp.id
							);
							if (index != -1)
								this.$set(
									this.chForm.inputs[index],
									'value',
									inp.value
								);
						}
					});
				}, 100);
			},
		},
		mounted() {
			WBS.send('private-read-singleForm', { cod: this.cod }, (resp) => {
				if ('success' == resp.status) {
					let oldValue = clone(this.value);
					this.chForm = resp.data;
					this.load(oldValue);
				}
			});
		},
	};
</script>



// WEBPACK FOOTER //
// src/app-components/sForm.vue